/* import __COLOCATED_TEMPLATE__ from './send-your-email.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();